import { render } from "./PageNumber11.vue?vue&type=template&id=b748e04e&scoped=true"
import script from "./PageNumber11.vue?vue&type=script&lang=js"
export * from "./PageNumber11.vue?vue&type=script&lang=js"

import "./PageNumber11.vue?vue&type=style&index=0&id=b748e04e&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b748e04e"]])

export default __exports__